import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setStep5 } from '../../../../modules/story/actions'
import { Card, CardActionArea, CardContent, CardMedia, Typography, Grid } from '@material-ui/core/'
import { newStory } from '../../constants.js'
import c from 'classnames'
import './index.scss'

const Step1 = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { step5 } = useSelector(({ story }) => story)

  const goTo = path => history.push(path)

  const onNext = (type, path) => {
    dispatch(setStep5({ type: type }))
    goTo(`/new-story/${path}/step/2`)
  }

  useEffect(() => {
    if (step5?.type) {
      dispatch(setStep5({ type: step5?.type }))
    }
  }, [step5?.type])

  return (
    <Grid className='categoryStoryStep'>
      <Typography className='titleGeneralStep'>
        What type of story do you want to share?
      </Typography>
      <Grid className='containerCardCategory'>
        {newStory.map((i, ind) => (
          <Grid key={ind} className='containerCardNewStory'>
            <Card className='cardNewStory' onClick={() => onNext(i?.type, i?.rout)}>
              <CardActionArea>
                <CardMedia
                  className='media'
                  image={i.src}
                />
                <CardContent>
                  <Typography className={c('cardTitle', !i?.color && 'cardTitle2')} align='center'>
                    {i.title}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Grid>
  )
}

export default Step1
